module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDZMOSAxN0w0IDEyIiBzdHJva2U9IiMxNENGOTYiIHN0cm9rZS13aWR0aD0iNCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/upsellEc/checked-icon.svg
// module id = 1233
// module chunks = 0